// extracted by mini-css-extract-plugin
export default {"topicSearchInput":"index_topicSearchInput__ypJct","topicSearchIcon":"index_topicSearchIcon__AwUVY"};